import React from 'react';
import { BiInfoCircle } from 'react-icons/bi';

import ChampDeTexte from '../../UI/ChampDeTexte/ChampDeTexte';
import CaseACocher from '../../UI/CaseACocher/CaseACocher';

import S from './TextInput.module.scss';

const TextInput = ({ argument, onChange }) => {
  const handleOptionChange = (field, value) => {
    const newOptions = {
      ...argument.options,
      [field]: value,
    };
    onChange('options', newOptions);
  };

  return (
    <div className={S.textContainer}>
      <div className={S.infoBox}>
        <BiInfoCircle size={16} />
        <span>
          Ce type d'argument permet la saisie de texte libre avec options de
          validation.
        </span>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Configuration</h6>

        <div className={S.champGroupe}>
          <label className={S.label}>Description</label>
          <ChampDeTexte
            value={argument.description || ''}
            onChange={(value) => onChange('description', value)}
            placeholder="Description de l'argument"
            multiline={true}
            rows={2}
          />
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>Valeur par défaut</label>
          <ChampDeTexte
            value={argument.valeurParDefaut || ''}
            onChange={(value) => onChange('valeurParDefaut', value)}
            placeholder="Texte par défaut"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.obligatoire || false}
            onChange={(checked) => onChange('obligatoire', checked)}
            label="Argument obligatoire"
          />
        </div>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Options spécifiques</h6>

        <div className={S.gridTwo}>
          <div className={S.champGroupe}>
            <label className={S.label}>Longueur minimum</label>
            <ChampDeTexte
              type="number"
              value={argument.options?.minLength || ''}
              onChange={(value) =>
                handleOptionChange('minLength', parseInt(value) || null)
              }
              placeholder="0"
              min="0"
            />
          </div>

          <div className={S.champGroupe}>
            <label className={S.label}>Longueur maximum</label>
            <ChampDeTexte
              type="number"
              value={argument.options?.maxLength || ''}
              onChange={(value) =>
                handleOptionChange('maxLength', parseInt(value) || null)
              }
              placeholder="Illimité"
              min="1"
            />
          </div>
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.multiline || false}
            onChange={(checked) => handleOptionChange('multiline', checked)}
            label="Texte multiligne (textarea)"
          />
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>Expression régulière de validation</label>
          <ChampDeTexte
            value={argument.options?.pattern || ''}
            onChange={(value) => handleOptionChange('pattern', value)}
            placeholder="Ex: ^[A-Za-z0-9]+$"
          />
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>Message d'erreur personnalisé</label>
          <ChampDeTexte
            value={argument.options?.errorMessage || ''}
            onChange={(value) => handleOptionChange('errorMessage', value)}
            placeholder="Message affiché en cas d'erreur de validation"
          />
        </div>
      </div>

      <div className={S.previewSection}>
        <h6 className={S.configTitle}>Aperçu de l'input utilisateur</h6>
        <div className={S.previewBox}>
          <div className={S.mockInput}>
            <div className={S.mockLabel}>
              {argument.nom || "Nom de l'argument"}
              {argument.obligatoire && <span className={S.required}>*</span>}
            </div>
            <div className={S.mockField}>
              {argument.options?.multiline
                ? 'Zone de texte (multiligne)'
                : 'Champ de texte'}
            </div>
            {argument.description && (
              <div className={S.mockDescription}>{argument.description}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextInput;
